import React from 'react';
import { PaneNode } from '../../types';
import { TabContainer } from '../tab-system/TabContainer';
import { SplitPane } from '../tab-system/SplitPane';
import { usePaneLayout } from "../stores/hooks/usePaneLayout"

/**
 * PaneRenderer
 * 
 * ペインレイアウトをレンダリングするコンポーネント
 * SplitPaneとTabContainerを再帰的にレンダリング
 */

interface PaneRendererProps {
  node: PaneNode;
  onTabDragStart?: (tabId: string, containerId: string, event: React.DragEvent) => void;
  onTabDragEnd?: () => void;
  onTabDrop?: (draggedTabId: string, targetContainerId: string, dropIndex?: number) => void;
}

export const PaneRenderer: React.FC<PaneRendererProps> = ({
  node,
  onTabDragStart,
  onTabDragEnd,
  onTabDrop
}) => {
  const { layout, updateSplitRatio } = usePaneLayout();
  
  if (node.type === 'container') {
    const isActive = layout.activeContainerId === node.id;
    
    return (
      <TabContainer
        container={node}
        isActive={isActive}
        onTabDragStart={onTabDragStart}
        onTabDragEnd={onTabDragEnd}
        onTabDrop={onTabDrop}
      />
    );
  }
  
  if (node.type === 'split') {
    // 新しいSplitPaneコンポーネントを使用
    return (
      <SplitPane
        node={node}
        onSplitRatioChange={updateSplitRatio}
        onTabDragStart={onTabDragStart}
        onTabDragEnd={onTabDragEnd}
        onTabDrop={onTabDrop}
      />
    );
  }
  
  return null;
};

export default React.memo(PaneRenderer);